var _                         = require('underscore');
var $                         = require('jquery');
var TrayTabContent            = require('./tray__tab__content.js');
var TrayTabListComponentsItem = require('./tray__tab__listcomponents__item.js');

/**
 * Creates an overlay tray large components
 *
 * @class
 */

class TrayTabListComponents extends TrayTabContent {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'numberOfResults': '0'
            }
        };
    }

    constructor(options) {
        super(options);

        var self = this;
        //viewConfig: contains properties related to UI [e.g., column names, search keys, etc]
        //view config is passed from TrayTab view
        if(options && options.viewConfig) {

            this.template = `
            <div class="editor__tray__listcomponents js-editor__tray__listcomponents"> 
                <div class="editor__tray__listcomponents__top js-editor__tray__listcomponents__top clearfix">
                 <div class="editor__tray__listcomponents__top__total">`;


                    if(!options.viewConfig.hideTotal){
                        this.template += `
                            Total: <span class='js-editor__tray__total_number_of_items'><%- numberOfResults %></span>`;
                    } else {
                        this.template += `
                            <span class='js-editor__tray__total_number_of_items'>-</span>`; // ?!?!? WHY do i need to do this (HTML SUCKS)
                    }

                this.template += `
                    </div>`;

                //sorting is enabled
                if(options.viewConfig.enableSorting) {
                    this.template += `
                    <a class='js-editor__tray__listcomponents__top__sort--dropdown'>
                        <div class="editor__tray__listcomponents__top__sortdropdown">
                            <div class="editor__tray__listcomponents__top__sortdropdown__select">
                                <select class='js-editor__tray__listcomponents__top__sortdropdown__select'>`;

                    options.viewConfig.columns.forEach(function(config) {
                        if(config.enableSorting)
                        self.template += `
                            <option data-sortkey=` + config.key + ` data-sortdirection='asc'>` + config.name +  ` Ascending</option>` +
                            `<option data-sortkey=` + config.key + ` data-sortdirection='desc'>` + config.name +  ` Descending</option>`;
                    });

                    this.template += `
                                </select>
                                <div class="editor__tray__listcomponents__top__sortdropdown__select__triangle">
                                    <%= embedded_svg("icon-dropdown-triangle") %>
                                </div>
                            </div>
                            <div class="editor__tray__listcomponents__top__sortdropdown__prefix">Sort By </div>
                        </div>
                    </a>`;

                    // first add items other than 'left items', if left overflow is enabled
                    options.viewConfig.columns.forEach(function(config) {
                        if(config.location &&  options.viewConfig.enableLeftOverflow && config.location === 'left') return; // skip
                        if(config.enableSorting){
                            self.template +=
                                `<a class='editor__tray__listcomponents__top__sort js-editor__tray__list__top__sort' data-sortkey=` + config.key + `>
                                    <div class="non-selectable editor__tray__listcomponents__top__` + ((config.location && config.location === 'right') ? 'rightitem' : config.name.toLowerCase()) + ` js-editor__tray__listcomponents__top__` + config.name.toLowerCase() +`">
                                        <div class="editor__tray__listcomponents__top__sort__arrow js-editor__tray__listcomponents__top__sort__arrow">
                                            <%= embedded_svg("icon-dropdown-arrow") %>
                                        </div>
                                        <div class="editor__tray__listcomponents__top__sort__name">` +
                                            config.name
                                        + `</div>
                                        
                                    </div>
                                </a>`
                        } else {
                            self.template +=
                                `<a class='editor__tray__listcomponents__top__nosort js-editor__tray__list__top__nosort' data-sortkey=` + config.key + `>
                                    <div class="non-selectable editor__tray__listcomponents__top__` + ((config.location && config.location === 'right') ? 'rightitem' : config.name.toLowerCase()) + ` js-editor__tray__listcomponents__top__` + config.name.toLowerCase() +`">
                                        <div class="editor__tray__listcomponents__top__nosort__name">` +
                                            config.name
                                        + `</div>
                                    </div>
                                </a>`
                        }
                    });

                    // next add 'left items' inside one div that can hide overflow
                    if(options.viewConfig.enableLeftOverflow){

                        self.template +="<div class='editor__tray__listcomponents__top__leftitems'>";
                        options.viewConfig.columns.forEach(function(config) {
                            if(config.location && config.location === 'left' || config.location === 'hub'){
                                if(config.enableSorting){
                                    self.template +=
                                        `<a class='editor__tray__listcomponents__top__sort js-editor__tray__list__top__sort' data-sortkey=` + config.key + `>
                                            <div class="non-selectable editor__tray__listcomponents__top__leftitem ">
                                                <div class="editor__tray__listcomponents__top__sort__name">` +
                                                    config.name
                                                + `</div>
                                                <div class="editor__tray__listcomponents__top__sort__arrow js-editor__tray__listcomponents__top__sort__arrow">
                                                    <%= embedded_svg("icon-dropdown-arrow") %>
                                                </div>
                                            </div>
                                        </a>`
                                } else {
                                    self.template +=
                                        `<a class='editor__tray__listcomponents__top__nosort js-editor__tray__list__top__nosort' data-sortkey=` + config.key + `>
                                            <div class="non-selectable editor__tray__listcomponents__top__leftitem ">
                                                <div class="editor__tray__listcomponents__top__nosort__name">` +
                                                    config.name
                                                + `</div>
                                            </div>
                                        </a>`
                                }
                            }
                        });
                        self.template +="</div>";
                    }
                } else {
                    // first do regular item content
                    options.viewConfig.columns.forEach(function(config) {
                        if(config.location && options.viewConfig.enableLeftOverflow && config.location === 'left') return;
                        self.template +=
                            `<a class='editor__tray__listcomponents__top__nosort js-editor__tray__list__top__nosort' data-sortkey=` + config.key + `>
                                <div class="non-selectable editor__tray__listcomponents__top__` + ((config.location && config.location === 'right') ? 'rightitem' : config.name.toLowerCase()) + ` js-editor__tray__listcomponents__top__` + config.name.toLowerCase() +`">
                                    <div class="editor__tray__listcomponents__top__nosort__name">` +
                                        config.name
                                    + `</div>
                                </div>
                            </a>`
                    });


                    if(options.viewConfig.enableLeftOverflow){

                        self.template +="<div class='editor__tray__listcomponents__top__leftitems'>";
                        options.viewConfig.columns.forEach(function(config) {
                            if(config.location && config.location === 'left'){
                                self.template +=
                                `<a class='editor__tray__listcomponents__top__nosort js-editor__tray__list__top__nosort' data-sortkey=` + config.key + `>
                                    <div class="non-selectable editor__tray__listcomponents__top__leftitem ">
                                        <div class="editor__tray__listcomponents__top__nosort__name">` +
                                            config.name
                                        + `</div>
                                    </div>
                                </a>`
                            }
                        });
                        self.template +="</div>";
                    }
                }

            

                this.template +=
                `</div>
            
                <div class="editor__tray__listcomponents__content js-editor__tray__content"></div>`;

                if(options.viewConfig.helpView && options.viewConfig.helpView.enable) {
                    this.template += `
                    <div class="grid">
                        <div class="grid__item one-whole">
                            <div class="editor__tray__cannotfind">
                                <div class="editor__tray__cannotfind__title">` + options.viewConfig.helpView.message.title + `</div>
                                <div class="editor__tray__cannotfind__expand">` + options.viewConfig.helpView.message.expand + `</div>
                                <div class="editor__tray__cannotfind__more_info">` + options.viewConfig.helpView.message.more_info + `</div>
                            </div>
                        </div>
                    </div>`;
                }

            this.template += `
            </div>`;
        }

        super.render();

        /**
         * Click item
         *
         * @fires TrayTabListComponents#_itemClicked
         */

        $('.js-editor__tray__list__top__sort', this.$el).on('click', this._itemClicked);

         /**
         * Dropdown change
         *
         * @fires TrayTabListComponents#_sortDropDownChange
         */

        $('.js-editor__tray__listcomponents__top__sortdropdown__select', this.$el).on('change', this._sortDropDownChange);
    }

    /**
     * @event TrayTabListComponents#Cioui:TrayTabItem:clicked
     * @property {String}Cioui:TrayTabSort:clicked
     * @returns {String} sort key
     */

    _itemClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabItem:Sort:clicked', $(e.currentTarget).data('sortkey'));
    }

    /**
     * @event TrayTabListComponents#Cioui:TrayTabItem:clicked
     * @property {String}Cioui:TrayTabSort:clicked
     * @returns {String} sort key
     */

    _sortDropDownChange(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabItem:SortDropdown:change', {
            'sortkey': $(e.currentTarget).find(':selected').data('sortkey'),
            'sortdirection': $(e.currentTarget).find(':selected').data('sortdirection')
        });
    }

    /*
     * Add an item to the tray content list
     * @param dataObj - json object
     * @param dataObj.name
     * @param dataObj.description
     * @param dataObj.thumbUrl
    */

    addItem(defaults, properties){
        var details = {};
        Object.assign(details, defaults);
        Object.assign(details, properties);

        var config = {
            target: $('.js-editor__tray__content', this.$el),
            fields: {
                "details": details
            }
        };

        if(this._options && this._options.viewConfig) {
            config.viewConfig = this._options.viewConfig;
        }

        return new TrayTabListComponentsItem(config);
    }

    /**
     * Set Sorting Active
     * @param {String} sortKey - string that searches for sortkey data selector
     */
    setSortingKeyActive(sortKey){
        this.clearSortingKey();
        if(sortKey.length > 0){
            $('[data-sortkey='+sortKey+']', this.$el).addClass("active");
        }
    }

    /**
     * Clear Sorting Active
     */
    clearSortingKey(){
        // clear previous state
        $('[data-sortkey]', this.$el).each(function(){
            $(this).removeClass('active');
        });
    }

    /**
     * Flip Sorting Arrow
     * @param {String} sortKey - string that searches for sortkey data selector
     * @param {String} direction - 'asc' or 'desc'
     */
    flipSortingArrow(sortKey, direction){
        this.clearSortingArrow();
        if(direction == 'asc' && sortKey.length > 0 && direction.length > 0){
            $('[data-sortkey='+sortKey+']', this.$el).find('.js-editor__tray__listcomponents__top__sort__arrow').addClass("flipped");
        }
    }

    /**
     * Clear Sorting Arrow
     */
    clearSortingArrow(){
        // clear previous state
        $('[data-sortkey]', this.$el).each(function(){
            $(this).find('.js-editor__tray__listcomponents__top__sort__arrow').removeClass('flipped');
        });
    }

    /**
     * Set Dropdown
     * @param {String} sortKey - string that searches for sortkey data selector
     */
    setDropdown(sortKey, sortdirection){
        if(sortKey.length > 0 && sortdirection.length > 0){
            $('[data-sortkey='+sortKey+'][data-sortdirection='+sortdirection+']', $('.js-editor__tray__listcomponents__top__sortdropdown__select',this.$el)).attr("selected", "selected");
        }
    }

    /*
     * Set the total number of items
    */

    setTotalNumberOfResults(numberOfResults){
        $('.js-editor__tray__total_number_of_items', this.$el).html(numberOfResults);
    }


}
module.exports = TrayTabListComponents;